import { t as e } from "../utils-DiFe-_ei.js";
import { t } from "../circle-CnwCz7ux.js";
import { t as n } from "../dist-DAt3we1k.js";
import { a as r, c as i, d as a, i as o, l as s, n as c, o as l, r as u, t as d, u as f } from "../dist-BBT9ugBv.js";
import * as p from "react";
import { Fragment as m, jsx as h, jsxs as g } from "react/jsx-runtime";
//#region ../../node_modules/.pnpm/@radix-ui+react-use-size@1.1.4_@types+react@19.2.17_react@19.2.7/node_modules/@radix-ui/react-use-size/dist/index.mjs
var _ = Object.defineProperty, v = (e, t) => _(e, "name", {
	value: t,
	configurable: !0
});
function y(e) {
	let [t, n] = p.useState(void 0);
	return i(() => {
		if (e) {
			n({
				width: e.offsetWidth,
				height: e.offsetHeight
			});
			let t = new ResizeObserver((t) => {
				if (!Array.isArray(t) || !t.length) return;
				let r = t[0], i, a;
				if ("borderBoxSize" in r) {
					let e = r.borderBoxSize, t = Array.isArray(e) ? e[0] : e;
					i = t.inlineSize, a = t.blockSize;
				} else i = e.offsetWidth, a = e.offsetHeight;
				n({
					width: i,
					height: a
				});
			});
			return t.observe(e, { box: "border-box" }), () => t.unobserve(e);
		} else n(void 0);
	}, [e]), t;
}
v(y, "useSize");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-radio-group@1.4.7_@types+react-dom@19.2.3_@types+react@19.2.17__@types+_51b26e47475cb4f01524807ff73fbc22/node_modules/@radix-ui/react-radio-group/dist/index.mjs
var b = Object.defineProperty, x = (e, t) => b(e, "name", {
	value: t,
	configurable: !0
}), S = "Radio", [C, w] = f(S), [T, E] = C(S);
function D(e) {
	let { __scopeRadio: t, checked: n = !1, children: r, disabled: i, form: a, name: o, onCheck: s, required: c, value: l = "on", internal_do_not_use_render: u } = e, [d, f] = p.useState(null), [m, g] = p.useState(null), _ = p.useRef(!1), [v, y] = p.useReducer((e) => e + 1, 0), b = {
		checked: n,
		disabled: i,
		required: c,
		name: o,
		form: a,
		value: l,
		control: d,
		setControl: f,
		hasConsumerStoppedPropagationRef: _,
		userInteractionCount: v,
		onUserInteraction: y,
		isFormControl: !d || !!a || !!d.closest("form"),
		bubbleInput: m,
		setBubbleInput: g,
		onCheck: /* @__PURE__ */ x(() => s?.(), "onCheck")
	};
	return /* @__PURE__ */ h(T, {
		scope: t,
		...b,
		children: P(u) ? u(b) : r
	});
}
x(D, "RadioProvider");
var O = "RadioTrigger", k = /* @__PURE__ */ p.forwardRef(/* @__PURE__ */ x(function({ __scopeRadio: e, onClick: t, ...r }, i) {
	let { checked: o, disabled: c, value: l, setControl: u, onCheck: d, hasConsumerStoppedPropagationRef: f, onUserInteraction: p, isFormControl: m, bubbleInput: g } = E(O, e), _ = a(i, u);
	return /* @__PURE__ */ h(s.button, {
		type: "button",
		role: "radio",
		"aria-checked": o,
		"data-state": F(o),
		"data-disabled": c ? "" : void 0,
		disabled: c,
		value: l,
		...r,
		ref: _,
		onClick: n(t, (e) => {
			o || (p(), d()), g && m && (f.current = e.isPropagationStopped(), f.current || e.stopPropagation());
		})
	});
}, "RadioTrigger")), A = "RadioIndicator", j = /* @__PURE__ */ p.forwardRef(/* @__PURE__ */ x(function(e, t) {
	let { __scopeRadio: n, forceMount: r, ...i } = e, a = E(A, n);
	return /* @__PURE__ */ h(d, {
		present: r || a.checked,
		children: /* @__PURE__ */ h(s.span, {
			"data-state": F(a.checked),
			"data-disabled": a.disabled ? "" : void 0,
			...i,
			ref: t
		})
	});
}, "RadioIndicator")), M = "RadioBubbleInput", N = /* @__PURE__ */ p.forwardRef(/* @__PURE__ */ x(function({ __scopeRadio: e, onClick: t, ...r }, i) {
	let { control: o, checked: c, required: l, disabled: u, name: d, value: f, form: m, bubbleInput: g, setBubbleInput: _, hasConsumerStoppedPropagationRef: v, userInteractionCount: b } = E(M, e), x = a(i, _), S = y(o), C = p.useRef(!1), w = p.useRef(c), T = p.useRef(b);
	p.useEffect(() => {
		let e = g;
		if (!e) return;
		let t = window.HTMLInputElement.prototype, n = Object.getOwnPropertyDescriptor(t, "checked").set, r = b !== T.current;
		T.current = b;
		let i = w.current !== c;
		w.current = c;
		let a = !(r && v.current);
		if (i && n) {
			C.current = !r;
			let t = new Event("click", { bubbles: a });
			n.call(e, c), e.dispatchEvent(t), C.current = !1;
		}
	}, [
		g,
		c,
		v,
		b
	]);
	let D = p.useRef(c);
	return /* @__PURE__ */ h(s.input, {
		type: "radio",
		"aria-hidden": !0,
		defaultChecked: D.current,
		required: l,
		disabled: u,
		name: d,
		value: f,
		form: m,
		...r,
		tabIndex: -1,
		ref: x,
		onClick: n(t, (e) => {
			C.current && e.stopPropagation();
		}),
		style: {
			...r.style,
			...S,
			position: "absolute",
			pointerEvents: "none",
			opacity: 0,
			margin: 0,
			transform: "translateX(-100%)"
		}
	});
}, "RadioBubbleInput"));
function P(e) {
	return typeof e == "function";
}
x(P, "isFunction");
function F(e) {
	return e ? "checked" : "unchecked";
}
x(F, "getState");
var I = [
	"ArrowUp",
	"ArrowDown",
	"ArrowLeft",
	"ArrowRight"
], L = "RadioGroup", [R, z] = f(L, [o, w]), B = o(), V = w(), [H, U] = R(L), W = /* @__PURE__ */ p.forwardRef(/* @__PURE__ */ x(function(e, t) {
	let { __scopeRadioGroup: n, name: i, form: o, defaultValue: c, value: d, required: f = !1, disabled: m = !1, orientation: g, dir: _, loop: v = !0, onValueChange: y, ...b } = e, S = B(n), C = r(_), [w, T] = l({
		prop: d,
		defaultProp: c ?? null,
		onChange: y,
		caller: L
	}), [E, D] = p.useState(null), O = a(t, D), k = p.useRef(w);
	return p.useEffect(() => {
		let e = o ? E?.ownerDocument.getElementById(o) : E?.closest("form");
		if (e instanceof HTMLFormElement) {
			let t = /* @__PURE__ */ x(() => T(k.current), "reset");
			return e.addEventListener("reset", t), () => e.removeEventListener("reset", t);
		}
	}, [
		E,
		o,
		T
	]), /* @__PURE__ */ h(H, {
		scope: n,
		name: i,
		form: o,
		required: f,
		disabled: m,
		value: w,
		onValueChange: T,
		children: /* @__PURE__ */ h(u, {
			asChild: !0,
			...S,
			orientation: g,
			dir: C,
			loop: v,
			children: /* @__PURE__ */ h(s.div, {
				role: "radiogroup",
				"aria-required": f,
				"aria-orientation": g,
				"data-disabled": m ? "" : void 0,
				dir: C,
				...b,
				ref: O
			})
		})
	});
}, "RadioGroup")), G = "RadioGroupItemProvider", K = "RadioGroupItemTrigger";
function q(e) {
	let { __scopeRadioGroup: t, value: n, disabled: r, children: i, internal_do_not_use_render: a } = e, o = U(G, t), s = V(t), c = o.disabled || r;
	return /* @__PURE__ */ h(D, {
		...s,
		checked: o.value === n,
		disabled: c,
		required: o.required,
		name: o.name,
		form: o.form,
		value: n,
		onCheck: () => o.onValueChange(n),
		internal_do_not_use_render: a,
		children: i
	});
}
x(q, "RadioGroupItemProvider");
var J = /* @__PURE__ */ p.forwardRef(/* @__PURE__ */ x(function(e, t) {
	let { __scopeRadioGroup: r, ...i } = e, o = B(r), s = V(r), { checked: l, disabled: u } = E(K, s.__scopeRadio), d = p.useRef(null), f = a(t, d), m = p.useRef(!1);
	return p.useEffect(() => {
		let e = /* @__PURE__ */ x((e) => {
			I.includes(e.key) && (m.current = !0);
		}, "handleKeyDown"), t = /* @__PURE__ */ x(() => m.current = !1, "handleKeyUp");
		return document.addEventListener("keydown", e), document.addEventListener("keyup", t), () => {
			document.removeEventListener("keydown", e), document.removeEventListener("keyup", t);
		};
	}, []), /* @__PURE__ */ h(c, {
		asChild: !0,
		...o,
		focusable: !u,
		active: l,
		children: /* @__PURE__ */ h(k, {
			...s,
			...i,
			ref: f,
			onKeyDown: n(i.onKeyDown, (e) => {
				e.key === "Enter" && e.preventDefault();
			}),
			onFocus: n(i.onFocus, () => {
				m.current && d.current?.click();
			})
		})
	});
}, "RadioGroupItemTrigger")), Y = /* @__PURE__ */ p.forwardRef(/* @__PURE__ */ x(function(e, t) {
	let { __scopeRadioGroup: n, value: r, disabled: i, ...a } = e;
	return /* @__PURE__ */ h(q, {
		__scopeRadioGroup: n,
		value: r,
		disabled: i,
		internal_do_not_use_render: ({ isFormControl: e }) => /* @__PURE__ */ g(m, { children: [/* @__PURE__ */ h(J, {
			...a,
			ref: t,
			__scopeRadioGroup: n
		}), e && /* @__PURE__ */ h(X, { __scopeRadioGroup: n })] })
	});
}, "RadioGroupItem")), X = /* @__PURE__ */ p.forwardRef(/* @__PURE__ */ x(function(e, t) {
	let { __scopeRadioGroup: n, ...r } = e;
	return /* @__PURE__ */ h(N, {
		...V(n),
		...r,
		ref: t
	});
}, "RadioGroupItemBubbleInput")), Z = /* @__PURE__ */ p.forwardRef(/* @__PURE__ */ x(function(e, t) {
	let { __scopeRadioGroup: n, ...r } = e;
	return /* @__PURE__ */ h(j, {
		...V(n),
		...r,
		ref: t
	});
}, "RadioGroupIndicator")), Q = p.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ h(W, {
	ref: r,
	className: e("grid gap-2", t),
	...n
}));
Q.displayName = W.displayName;
var $ = p.forwardRef(({ className: n, ...r }, i) => /* @__PURE__ */ h(Y, {
	ref: i,
	className: e("aspect-square h-4 w-4 shrink-0 rounded-full border border-primary text-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50", n),
	...r,
	children: /* @__PURE__ */ h(Z, {
		className: "flex items-center justify-center",
		children: /* @__PURE__ */ h(t, { className: "h-2 w-2 fill-current text-current" })
	})
}));
$.displayName = Y.displayName;
//#endregion
export { Q as RadioGroup, $ as RadioGroupItem };

//# sourceMappingURL=radio-group.js.map